import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import confirmDelete from '../../components/ConfirmDelete';
import ImgToolTip from '../ImgTooltip';
import TitleTooltip from '../TitleTooltip';

const RoomRow = ({ login, name, order, id, deleteFn, intl }) => {
  
  return (
    <div className="added-event-container">
      <div className="e-name-container">
        <div className="e-name">
          <div className="event-icon-container">
            <img
              className="event-icon rounded-circle"
              src={`https://ui-avatars.com/api/?name=${name}&size=85&color=ff7142`}
              alt=""
            />
          </div>
          <div className="m-l-45">
            {name && name.length > 69 ? <TitleTooltip title={name} placement="bottom" id={id} /> : <h6>{name}</h6> }
            <span className="font-13"><b>{intl.formatMessage({ id: 'input.room.login' })}{': '}</b>{login}</span>
          </div>
        </div>
        <div className="del-event-container align-items-center">
          <Button
            onClick={() => {
              confirmDelete(intl, id, undefined, (_id) => {
                deleteFn(_id)
              }, intl.formatMessage({id: 'action.delete-room'}));
            }}
          >
            <ImgToolTip className="icon-normal" intl={intl} placement="left" tooltiptext={`action.delete-room`} id="tooltip-download-latest" img={`/icons/delete.png`} />
            <ImgToolTip className="icon-hover" intl={intl} placement="left" tooltiptext={`action.delete-room`} id="tooltip-download-latest-hover" img={`/icons/delete-hover.png`} />
            <ImgToolTip className="icon-focus" intl={intl} placement="left" tooltiptext={`action.delete-room`} id="tooltip-download-latest-focus" img={`/icons/delete-focus.png`} />
          </Button>
          <span className="font-13"><b>{intl.formatMessage({ id: 'input.room.order' })}{': '}</b>{order}</span>
        </div>
      </div>
      <Link className="d-flex w-10" to={`/room/edit/${id}`}>
          <Button className="btn-return">{intl.formatMessage({id: 'edit-new'})}</Button>
      </Link>
    </div>
  );
};

export default injectIntl(RoomRow);
